<script setup>
/* eslint-env vue/setup-compiler-macros */
import { useI18n } from '@/i18n'
import { computed } from 'vue'
import DOMPurify from 'dompurify'

const props = defineProps({
  description: { type: String, default: '' }
})

const { t } = useI18n()
const sanitizedDescription = computed(() => {
  if (!props.description) return ''
  return DOMPurify.sanitize(props.description, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'code', 'pre', 'a'],
    ALLOWED_ATTR: {
      a: ['href', 'rel', 'target'],
    },
    RETURN_TRUSTED_TYPE: false,
  })
})
</script>

<template>
  <pFieldset v-if="props.description" class="legend-transparent dashboard-widget">
    <template #legend>
      <div class="flex items-center pl-2">
        <span class="font-bold p-2">{{ t('siemWorkflowDetails.description') }}</span>
      </div>
    </template>
    <div class="description-body" v-html="sanitizedDescription" />
  </pFieldset>
</template>

<style scoped>
.description-body {
  font-size: .9rem;
  line-height: 1.65;
  color: var(--p-text-color);
}

.description-body :deep(p)  { margin: 0 0 .5rem; }
.description-body :deep(ul),
.description-body :deep(ol) { padding-left: 1.4rem; margin: 0 0 .5rem; }
.description-body :deep(code) {
  font-family: ui-monospace, monospace;
  font-size: .85em;
  background: var(--p-surface-100, rgba(0,0,0,.04));
  padding: 1px 5px;
  border-radius: 4px;
}
</style>
